import { render, staticRenderFns } from "./BatchActions.vue?vue&type=template&id=c81d6e08&scoped=true&"
import script from "./BatchActions.vue?vue&type=script&lang=js&"
export * from "./BatchActions.vue?vue&type=script&lang=js&"
import style0 from "./BatchActions.vue?vue&type=style&index=0&id=c81d6e08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81d6e08",
  null
  
)

export default component.exports